import { InfoOutlined, LocalOfferOutlined, PercentOutlined } from "@mui/icons-material";
import { Box, Checkbox, FormControlLabel, InputAdornment, Radio, RadioGroup, Switch, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Campo from "../Campo";
import { PRECIO_MAXIMO_EVENTO } from "../../utils";

const tarjetaSx = { border: "1px solid #DFD7FC", borderRadius: "13px", overflow: "hidden", background: "linear-gradient(120deg, #fff, #FAF8FF)" };
const cabeceraSx = { display: "flex", alignItems: "center", gap: 1.75, px: 2, py: 0.75, minHeight: 34, background: "linear-gradient(100deg, #F7F4FF, #F0EBFD)", color: "#271A78", "& svg": { fontSize: 25 } };
const etiquetaSx = { m: 0, display: "flex", alignItems: "center", gap: 1.5, "& .MuiFormControlLabel-label": { ml: 0, transform: "none" } };
const opciones = [
  { valor: "COMPRADOR", titulo: "Tarifa de cada comprador", detalle: "Según el DNI ingresado; sin DNI o fuera de la comunidad UPrO, tarifa Particular." },
  { valor: "FIJO", titulo: "Precio fijo", detalle: "El mismo precio para todos los platos y compradores." },
];
const radioSx = {
  width: 20, height: 20, mr: 0, flexShrink: 0, borderColor: "#BDC4D3",
  "&.Mui-checked": { borderColor: "#4AB8AC", backgroundColor: "#4AB8AC", backgroundImage: "radial-gradient(circle, #fff 0 3.5px, rgba(255,255,255,0) 4px)" },
  "&.Mui-disabled": { opacity: 0.45 },
};
const checkboxSx = {
  width: 22, height: 22, mr: 0, flexShrink: 0, borderRadius: "4px", borderColor: "#B9C2D2",
  "&.Mui-checked": {
    borderColor: "#8452F5", backgroundColor: "#7946F5",
    backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\")",
  },
  "&.Mui-disabled": { opacity: 0.45 },
};
const switchSx = {
  width: 48, height: 24, mr: 0, flexShrink: 0,
  "& .MuiSwitch-thumb": { width: 20, height: 20, boxShadow: "0 1px 3px rgba(0,0,0,.12)" },
  "& .MuiSwitch-switchBase": { transform: "translate(2px, -50%)" },
  "& .MuiSwitch-switchBase.Mui-checked": { transform: "translate(26px, -50%)" },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#0BB38D !important", borderColor: "#0BB38D !important" },
};

export default function PasoMenu({ form, setField, errores, soloLectura }) {
  return (
    <Box sx={{ display: "grid", gap: 1.75 }}>
      <Box sx={{
        display: "grid", alignItems: "center", gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "auto 1px minmax(0, 1fr)" },
        gap: { xs: 1, md: 2.5 }, px: 1.5, py: 0.75, borderRadius: "12px", background: "linear-gradient(100deg, #ECF8F1, #E4F4F7)",
      }}>
        <FormControlLabel sx={{ ...etiquetaSx, gap: 1.75 }}
          control={<Switch checked={form.menuUniversitario} disabled={soloLectura} onChange={(_, value) => setField("menuUniversitario", value)}
            inputProps={{ "aria-label": "Vender platos del menú universitario" }} sx={switchSx} />}
          label={<Typography sx={{ fontSize: 13, fontWeight: 700, color: "#19153B" }}>Vender platos del menú universitario</Typography>} />
        <Box sx={{ display: { xs: "none", md: "block" }, height: 24, background: "#AFB9CA" }} />
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
          <InfoOutlined sx={{ fontSize: 22, color: "#00A0DD", flexShrink: 0 }} />
          <Typography sx={{ fontSize: 12, color: "#38506F" }}>Se ofrecen los platos del cronograma del día para el turno más cercano a la hora actual.</Typography>
        </Box>
      </Box>

      {form.menuUniversitario && (
        <>
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(2, minmax(0, 1fr))" }, gap: 2 }}>
            <Box sx={tarjetaSx}>
              <Box sx={cabeceraSx}><LocalOfferOutlined /><Typography component="h3" id="evento-menu-tarifa" sx={{ fontSize: 14, fontWeight: 700, color: "#20164A" }}>Precio de cada plato</Typography></Box>
              <RadioGroup aria-labelledby="evento-menu-tarifa" value={form.menuModoPrecio} onChange={(e) => setField("menuModoPrecio", e.target.value)} sx={{ p: 1, gap: 0.25 }}>
                {opciones.map((opcion) => (
                  <FormControlLabel key={opcion.valor} value={opcion.valor} control={<Radio disabled={soloLectura} sx={radioSx} />}
                    sx={{ ...etiquetaSx, px: 1.25, py: 0.75, minHeight: 43, borderRadius: "10px", background: form.menuModoPrecio === opcion.valor ? "linear-gradient(100deg, #F0EBFF, #EFE9FD)" : "rgba(0,0,0,0)" }}
                    label={<Box>
                      <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1D173A" }}>{opcion.titulo}</Typography>
                      <Typography sx={{ fontSize: 12, color: "#6A769B", mt: 0.15 }}>{opcion.detalle}</Typography>
                    </Box>} />
                ))}
              </RadioGroup>
            </Box>
            <Box sx={tarjetaSx}>
              <Box sx={cabeceraSx}><PercentOutlined /><Typography component="h3" sx={{ fontSize: 14, fontWeight: 700, color: "#20164A" }}>Descuento</Typography></Box>
              <Box sx={{ p: { xs: 1.75, sm: 2.25 } }}>
                <FormControlLabel sx={{ ...etiquetaSx, gap: 1.75 }}
                  control={<Checkbox checked={form.descuentosClientes?.menuUniversitarioAplicaDescuento !== false} disabled={soloLectura} sx={checkboxSx}
                    onChange={(_, value) => setField("descuentosClientes", { ...form.descuentosClientes, menuUniversitarioAplicaDescuento: value })} />}
                  label={<Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1C1638" }}>Aplicar descuento de Facturación al menú universitario</Typography>} />
              </Box>
            </Box>
          </Box>
          {form.menuModoPrecio === "FIJO" && (
            <Box sx={{ width: { xs: "100%", md: "35%" }, minWidth: { md: 280 }, maxWidth: "100%", px: { sm: 1 } }}>
              <Campo id="evento-precio-menu" label="Precio fijo" requerido error={errores.menuUniversitarioPrecio}>
                <TextField id="evento-precio-menu" type="number" fullWidth size="small" value={form.menuUniversitarioPrecio} placeholder="Ingrese el precio fijo" disabled={soloLectura}
                  onChange={(e) => setField("menuUniversitarioPrecio", e.target.value)} error={Boolean(errores.menuUniversitarioPrecio)}
                  inputProps={{ min: 0.01, max: PRECIO_MAXIMO_EVENTO, step: 0.01 }}
                  InputProps={{ startAdornment: <InputAdornment position="start" sx={{ ml: 1.25, mr: 0 }}><Typography sx={{ fontSize: 15, fontWeight: 700, color: "#30496A" }}>$</Typography></InputAdornment> }}
                  sx={{
                    "& .MuiOutlinedInput-root": { display: "flex !important", p: "0 !important", minHeight: 36, borderRadius: "9px !important", borderColor: "#CFD2E0", background: "linear-gradient(180deg, #fff, #FCFCFF)" },
                    "& .MuiInputBase-input": { fontSize: 13, p: "6px 12px !important", minWidth: 0, width: "100% !important", flex: "1 1 0", boxSizing: "border-box" },
                    "& .MuiOutlinedInput-root.Mui-focused:not(.Mui-error)": { borderColor: "#7953DE" },
                    "& .MuiOutlinedInput-root.Mui-error": { borderColor: "#E84B65" },
                    "& input[type=number]": { MozAppearance: "textfield" },
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button": { WebkitAppearance: "none", margin: 0 },
                  }} />
              </Campo>
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

PasoMenu.propTypes = {
  form: PropTypes.object.isRequired,
  setField: PropTypes.func.isRequired,
  errores: PropTypes.object.isRequired,
  soloLectura: PropTypes.bool,
};

PasoMenu.defaultProps = { soloLectura: false };
